"use client";

import { useEffect } from "react";
import { useAppData } from "@/store/appStore";
import { getCityList } from "@/app/product/_actions/city.actions";
import { clientLogger } from "@/lib/logger";

const CityListInitializer = ({ children }: { children: React.ReactNode }) => {
	const [appData, setData, setCookielessData] = useAppData();

	useEffect(() => {
		let cancelled = false;

		const fetchStart = performance.now();
		const fetchCities = async () => {
			try {
				const cities = await getCityList();
				const cityListDurationMs = Math.round(performance.now() - fetchStart);
				console.log("[perf] cityList fetch", {
					durationMs: cityListDurationMs,
					count: cities?.length || 0,
				});
				clientLogger.info("[perf] cityList fetch", {
					durationMs: cityListDurationMs,
					count: cities?.length || 0,
				});
				if (!cancelled) {
					setCookielessData({ cityList: cities || [] });
					if (!appData?.cityId && cities?.length) {
						setData({ cityId: cities[0].id });
					}
				}
			} catch (error) {
				clientLogger.error("Error fetching city list", error as Error);
				if (!cancelled) {
					setCookielessData({ cityList: [] });
				}
			}
		};

		fetchCities();

		return () => {
			cancelled = true;
		};
	}, [setCookielessData]);

	return <>{children}</>;
};

export default CityListInitializer;
